import { NgSelectModule } from '@ng-select/ng-select';
import { ApyKeyInterceptor } from './core/interceptor/apy-key.interceptor';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import {LayoutModule} from '@angular/cdk/layout';
import { ModalDatosUsuarioComponent } from './pages/llamados/components/modal-datos-usuario/modal-datos-usuario.component';
import { LoginComponent } from './pages/login/login.component';
import { LlamadosComponent } from './pages/llamados/llamados.component';
import { ModalMotivosPausaComponent } from './pages/llamados/components/modal-motivos-pausa/modal-motivos-pausa.component';
import { ModalPausaComponent } from './pages/llamados/components/modal-pausa/modal-pausa.component';
import { ModalExcepcionFilaComponent } from './pages/llamados/components/modal-excepcion-fila/modal-excepcion-fila.component';
import { ModalCerrarSesionComponent } from './pages/llamados/components/modal-cerrar-sesion/modal-cerrar-sesion.component';
import { ModalDerivarAtencionComponent } from './pages/llamados/components/modal-derivar-atencion/modal-derivar-atencion.component';
import { ModalAtencionRemotaComponent } from './pages/llamados/components/modal-atencion-remota/modal-atencion-remota.component';
import { IndexComponent } from './pages/index/index.component';
import { ModalPreguntaComponent } from './pages/login/components/modal-pregunta/modal-pregunta.component';
import { ModalAnulacionComponent } from './pages/llamados/components/modal-anulacion/modal-anulacion.component';
import { ModalMotivosAtencionComponent } from './pages/llamados/components/modal-motivos-atencion/modal-motivos-atencion.component';
import { ModalErrorComponent } from './pages/llamados/components/modal-error/modal-error.component';
import { ModalOfflineComponent } from './pages/llamados/components/modal-offline/modal-offline.component';
import { ClipboardModule } from 'ngx-clipboard';
import { ModalMotivosAtencionClaroComponent } from './pages/llamados/components/modal-motivos-atencion-claro/modal-motivos-atencion-claro.component';
import { ModalLlamadoPacienteComponent } from './pages/llamados/components/modal-llamado-paciente/modal-llamado-paciente.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LlamadosComponent,
    ModalMotivosPausaComponent,
    ModalPausaComponent,
    ModalExcepcionFilaComponent,
    ModalCerrarSesionComponent,
    ModalDerivarAtencionComponent,
    ModalAtencionRemotaComponent,
    IndexComponent,
    ModalPreguntaComponent,
    ModalAnulacionComponent,
    ModalMotivosAtencionComponent,
    ModalErrorComponent,
    ModalOfflineComponent,
    ModalMotivosAtencionClaroComponent,
    ModalDatosUsuarioComponent,
    ModalLlamadoPacienteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ClipboardModule,
    LayoutModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot()
  ],
  exports: [ModalModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApyKeyInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
